import { Container, Modal, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

import StudentsView from '@/containers/students/StudentsView'
import { Channel as ChannelType, Site as SiteType } from '@/types'

interface Props {
  open: boolean
  onClose: () => void
  siteData: SiteType
  channelData?: ChannelType
}

export default function StudentModal({ open, onClose, siteData, channelData }: Props) {
  const theme = useMantineTheme()
  const isXs = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)
  const isSm = useMediaQuery(`(max-width: ${theme.breakpoints.sm}px)`)

  return (
    <Modal
      overflow="inside"
      opened={open}
      onClose={onClose}
      closeButtonLabel="Fechar"
      zIndex={201}
      size="100%"
      styles={{ modal: { height: '90vh' } }}>
      <Container px="lg" py="lg" size="xl" fluid>
        <Title order={isXs ? 4 : isSm ? 3 : 2}>Para quem está comprando?</Title>
        <Text mb="lg" size="lg" color="dimmed">
          Selecione o perfil de compra que deseja utilizar:
        </Text>
        <StudentsView initialData={{ site: siteData, channel: channelData }} modalView={true} />
      </Container>
    </Modal>
  )
}
